module.exports = __webpack_public_path__ + "img/img_lianxi_wuhan@3x.561e1b53.png";